import styled from '@emotion/styled';
import classNames from 'classnames';
import React from 'react';
import { text_styles, Typography } from '../../foundation';

type Alignment = 'center' | 'leading' | 'trailing';

const TEXT_ALIGNMENT_BY_ALIGNMENT: Record<Alignment, string> = {
  leading: 'left',
  trailing: 'right',
  center: 'center',
};

type TextElement = keyof Pick<
  JSX.IntrinsicElements,
  'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6' | 'p' | 'div' | 'span' | 'li'
>;

export interface BaseTextProps extends React.Attributes {
  alignment?: Alignment;
  /** @default 'span' */
  as?: TextElement;
  color?: string;
  /** @default Body_13_Regular
   * 'inherit'으로 부모 스타일을 상속받을 수 있습니다.
   *  */
  kind?: Typography | 'inherit';
}

export const BaseText: React.FC<BaseTextProps & JSX.IntrinsicElements[TextElement]> = ({
  as = 'span',
  kind = 'Body_13_Regular',
  children,
  className,
  ...props
}) => {
  return (
    <Base className={classNames('pds-text', className)} as={as} kind={kind} {...props}>
      {children}
    </Base>
  );
};

const Base = styled.span<BaseTextProps>`
  margin: 0;
  ${({ kind }) => {
    // kind가 'inherit'이면 부모 스타일 상속
    if (kind === 'inherit') return '';
    return text_styles[kind ?? ('Body_13_Regular' as Typography)];
  }};
  ${({ color }) => color && `color: ${color}`};
  ${({ alignment }) => alignment && `text-align: ${TEXT_ALIGNMENT_BY_ALIGNMENT[alignment]}`};
`;
